import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";

@Component({
  selector: "app-empty",
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ["./empty.component.scss"],
  template: `
		<section class="app-empty p-w-full p-h-full p-flex-col p-flex-center p-flex-gap-lg p-text-center p-content--xl">
			<img
				class="app-empty__image"
				[class.app-empty__image--sm]="imageSize() === 'sm'"
				[src]="svgSrc()"
				[alt]="imageAlt()"
			/>

			<div class="app-empty__content p-flex-col p-flex-gap-lg">
				<h1 class="p-text-title-lg">{{ displayTitle() }}</h1>
				<p class="p-text-body p-color-text-secondary">{{ displayBody() }}</p>
			</div>

			@if (!isNoMatches()) {
				<div class="app-empty__actions p-flex p-flex-center p-flex-gap-xs p-flex-wrap">
					<ng-content></ng-content>
				</div>
			}
		</section>
	`,
})
export class EmptyComponent {
  readonly svgSrc = input.required<string>();
  /** Overrides the default "Create your first <entity>" title. */
  readonly title = input("");
  readonly body = input("");
  /** Singular entity name, e.g. "deployment". Used for the default title. */
  readonly entity = input("");
  /** Current search text. A non-empty value switches to the "no matches" state. */
  readonly query = input("");
  /** True when the underlying list has items that are hidden by the current search or filters. */
  readonly hasItems = input(false);
  readonly imageAlt = input("");
  readonly imageSize = input<"sm" | "md">("md");

  protected readonly isNoMatches = computed(() => this.hasItems() || this.query().trim().length > 0);

  protected readonly displayTitle = computed(() => {
    if (this.isNoMatches()) {
      const q = this.query().trim();
      return q ? `No matches found for "${q}"` : "No matches found";
    }
    return this.title() || `Create your first ${this.entity()}`;
  });

  protected readonly displayBody = computed(() =>
    this.isNoMatches() ? "Try adjusting your search or filters." : this.body(),
  );
}
